  <div 
  class="d-flex flex-column flex-shrink-0 bg-dark side-bar-container"
  [ngClass]="{ 'collapsed': collapsed }"
>
  <div class="menu-flex">
    <div class="admin-head nav-link cursor-pointer text-red" [ngClass]="{'logo':collapsed}">
      <img *ngIf="collapsed" src="assets/logo/red_resized.png" width="40px" height="30px" alt="Toob Logo" class="toob-logo ms-2" >
      <img *ngIf="!collapsed" src="assets/logo/red_resized.png" width="40px" height="30px" alt="Toob Logo" class="toob-logo ms-2" >
      <img *ngIf="!collapsed" src="assets/logo/red_text_resized.png" width="100px"  alt="Toob Logo" class="toob-logo ms-2" >
      <!-- <span *ngIf="!collapsed" class="align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none text-white fs-3">&nbsp;Admin</span> -->
    </div>
    
  </div>

  <hr>

  <ul class="nav nav-pills flex-column mb-auto" [ngClass]="{ 'text-center': collapsed }">
    <li class="nav-item cursor-pointer" >
      <a [routerLink]="['admin/home']" routerLinkActive #rlaHome="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link text-white cursor-pointer"
         [ngClass]="{ 'active': rlaHome.isActive }" matRipple>
        <i class="bi bi-house-door"></i>
        <span *ngIf="!collapsed"> Home </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/admin-dashboard']" 
         routerLinkActive #rlaDashboard="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaDashboard.isActive }" matRipple>
        <i class="bi bi-speedometer2"></i>
        <span *ngIf="!collapsed"> Dashboard </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/manage-categories']" 
         routerLinkActive #rlaCat="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaCat.isActive }" matRipple>
        <i class="bi bi-diagram-3"></i>
        <span *ngIf="!collapsed"> Category Management </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/manage-products']" 
         routerLinkActive #rlaProduct="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaProduct.isActive }" matRipple>
        <i class="bi bi-ui-checks-grid"></i>
        <span *ngIf="!collapsed"> Product Management </span>
      </a>
    </li>

    <li>
      <a [routerLink]="['admin/manage-product-groups']" 
         routerLinkActive #rlaProductGroups="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaProductGroups.isActive }" matRipple>
         <i class="bi bi-filter-square"></i>
        <span *ngIf="!collapsed"> Product Groups </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/manage-customers']" 
         routerLinkActive #rlaCustomer="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaCustomer.isActive }" matRipple>
        <i class="bi bi-person-circle"></i>
        <span *ngIf="!collapsed"> Customer Management </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/manage-order']" 
         routerLinkActive #rlaOrder="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaOrder.isActive }" matRipple>
         <i class="bi bi-receipt"></i>
        <span *ngIf="!collapsed"> Order Management </span>
      </a>
    </li>
    <li>
      <a [routerLink]="['admin/manage-rbac-roles']" 
         routerLinkActive #rlaSettings="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaSettings.isActive }" matRipple>
         <i class="bi bi-gear"></i>
        <span *ngIf="!collapsed"> RBAC Management </span>
      </a>
    </li>

    <li>
      <a [routerLink]="['admin/manage-feeds']" 
         routerLinkActive #rlaFeeds="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaFeeds.isActive }" matRipple>
         <i class="bi bi-rss"></i>
        <span *ngIf="!collapsed"> Feed Management </span>
      </a>
    </li>

    <li *ngIf="isPlatformAdmin$ | async">
      <a [routerLink]="['admin/platform/manage-tenants']" 
         routerLinkActive #rlaPapiKey="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaPapiKey.isActive }" matRipple>
         <i class="bi bi-buildings"></i>
        <span *ngIf="!collapsed"> Manage Tenants </span>
      </a>
    </li>

    <li *ngIf="(isTenantAdmin$ | async) || (isPlatformAdmin$ | async)">
      <a [routerLink]="['admin/manage-users']" 
         routerLinkActive #rlaUsers="routerLinkActive"
         [routerLinkActiveOptions]="{ exact: true }"
         class="nav-link cursor-pointer text-white"
         [ngClass]="{ 'active': rlaUsers.isActive }" matRipple>
         <i class="bi bi-person-vcard"></i>
        <span *ngIf="!collapsed"> Manage Users </span>
      </a>
    </li>

  </ul>

  <hr>

  <div class="dropdown text-center">
    <a href="#" 
       class="d-flex align-items-center justify-content-center text-decoration-none dropdown-toggle text-white"
       data-bs-toggle="dropdown" aria-expanded="false">
      <img src="https://github.com/mdo.png" alt="Profile" width="32" height="32" class="rounded-circle me-2">
      <strong *ngIf="!collapsed">mdo</strong>
    </a>
    
    <ul class="dropdown-menu text-small shadow" [class.dropdown-collapsed]="collapsed">
      <li><a class="dropdown-item" href="#">New project...</a></li>
      <li><a class="dropdown-item" href="#">Settings</a></li>
      <li><a class="dropdown-item" href="#">Profile</a></li>
      <li><hr class="dropdown-divider"></li>
      <li><a (click)="signIn()" [hidden]="admin_logged_in" class="dropdown-item">Sign In</a></li>
      <li><a (click)="signOut()" [hidden]="!admin_logged_in" class="dropdown-item">Sign Out</a></li>
    </ul>
  </div>
  <hr>
  <div class="d-flex align-items-center justify-content-center text-decoration-none text-white cursor-pointer" (click)="toggleCollapse()">
    <i [class]="collapsed ? 'bi bi-layout-sidebar-inset-reverse' : 'bi bi-layout-sidebar-inset'"></i>
  </div>
  
  
</div>
